import Nav from './components/nav';
import Home from './controllers/home';
import Landing from './controllers/landing';
import Page from './controllers/page';

document.addEventListener('DOMContentLoaded', () => {
  new Nav();

  const classes = document.body.classList;
  switch ( true ) {
    // case classes.contains('home'):
    //   new Home();
    //   break;

    case classes.contains('page-template-landing'):
      new Landing();
      break;
    
    default:
      new Page();
  }
});